import React from 'react'
import styled from 'styled-components'
import { Media } from '../../theme'
import nabshow from './nabshow.png'
import { navigate } from 'gatsby'
import { useLocation } from '@reach/router'
import intl from 'react-intl-universal'
const Tip = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(270deg, #fd5c1f 0%, #fd8e1f 50%, #fd5c1f 100%);
  text-align: left;
  position: fixed;
  top: 0;
  z-index: 4800;
  cursor: pointer;
  div {
    margin-left: 40px;
  }
  p {
    font-size: 30px;
  }
  span {
    font-size: 16px;
  }
  .topnotice-arrow {
    margin-left: 10px;
    transition: transform 0.3s ease-in-out;
  }
  :hover {
    .topnotice-arrow {
      transform: translateX(10px);
    }
  }
  .topnotice-arrow-right {
    position: absolute;
    right: 60px;
  }
  ${Media.phone`
      font-size: 12px;
      height: 60px;
      span {
        width: 6.7rem;
      }
    `}
`

const Placeholder = styled.div`
  height: 80px;
`

const TopNotice = ({ onClose }) => {
  return (
    <>
      <Placeholder />
      <Tip
        onClick={() => {
          const locale = intl.getInitOptions().currentLocale
          const path = locale === 'en-US' ? `/applynab/` : `/${locale}/applynab/`
          if (typeof window !== 'undefined') {
            sessionStorage.setItem('topNoticeClosed', 'true')
          }
          navigate(path)
        }}
      >
        <img style={{ marginBottom: '0' }} src={nabshow} alt='topnotice' />
        <div>
          <p>
            Meet us at NAB Show 2025, April 6-9 Las Vegas!
            <svg
              className='topnotice-arrow'
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              fill='none'
              version='1.1'
              width='22.484375'
              height='15.55615234375'
              viewBox='0 0 22.484375 15.55615234375'
            >
              <g>
                <g transform='matrix(0.7071067094802856,0.7071067094802856,-0.7071067094802856,0.7071067094802856,4.600452607963234,-9.692409223411232)'>
                  <path
                    d='M23,1.70703125L23,10.70703125L25,10.70703125L25,-0.29296875L14,-0.29296875L14,1.70703125L23,1.70703125Z'
                    fill-rule='evenodd'
                    fill='#FFFFFF'
                    fill-opacity='1'
                  />
                </g>
                <g>
                  <rect x='0' y='6.7783203125' width='20' height='2' rx='0' fill='#FFFFFF' fill-opacity='1' />
                </g>
              </g>
            </svg>
          </p>
          <span>Reserve your meeting slot now before they're gone.</span>
        </div>
        <svg
          onClick={event => {
            event.stopPropagation()
            onClose()
          }}
          className='topnotice-arrow-right'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
          fill='none'
          version='1.1'
          width='40'
          height='40'
          viewBox='0 0 40 40'
          style={{ zIndex: 1000 }}
        >
          <defs>
            <clipPath id='master_svg0_101_2733'>
              <rect x='0' y='0' width='40' height='40' rx='0' />
            </clipPath>
          </defs>
          <g clip-path='url(#master_svg0_101_2733)'>
            <g>
              <path
                d='M12.37519475,10.959515906250001L29.04176875,27.626103906250002Q29.18236875,27.76670390625,29.25846875,27.95050390625Q29.33466875,28.13430390625,29.33466875,28.33320390625Q29.33466875,28.43170390625,29.31536875,28.52830390625Q29.29616875,28.62490390625,29.25846875,28.71580390625Q29.22086875,28.80680390625,29.16606875,28.88870390625Q29.11136875,28.97060390625,29.04176875,29.04030390625Q28.97206875,29.10990390625,28.89016875,29.16460390625Q28.80826875,29.21940390625,28.71726875,29.25700390625Q28.62636875,29.29470390625,28.52976875,29.31390390625Q28.43316875,29.33320390625,28.33466875,29.33320390625Q28.13576875,29.33320390625,27.95196875,29.25700390625Q27.76816875,29.18090390625,27.627568750000002,29.04030390625L10.96086175,12.37361090625Q10.82020975,12.23295890625,10.74408875,12.04918690625Q10.66796875,11.86541590625,10.66796875,11.66650390625Q10.66796875,11.56801250625,10.687183749999999,11.47141390625Q10.70639875,11.37481490625,10.74408975,11.28382090625Q10.78178075,11.19282590625,10.83649875,11.11093390625Q10.89121775,11.02904090625,10.96086175,10.95939690625Q11.03050575,10.88975290625,11.11239875,10.83503390625Q11.19429075,10.78031590625,11.28528575,10.74262490625Q11.37627975,10.70493390625,11.47287875,10.685718906249999Q11.56947735,10.66650390625,11.66796875,10.66650390625Q11.86688075,10.66650390625,12.05065175,10.74262390625Q12.23442375,10.81874490625,12.37507575,10.95939690625L12.37519475,10.959515906250001Z'
                fill-rule='evenodd'
                fill='#FFFFFF'
                fill-opacity='1'
              />
            </g>
            <g>
              <path
                d='M29.04176875,12.37360990625Q29.18236875,12.23295790625,29.25846875,12.04918690625Q29.33466875,11.86541590625,29.33466875,11.66650390625Q29.33466875,11.56801250625,29.31536875,11.47141390625Q29.29616875,11.37481490625,29.25846875,11.28382090625Q29.22086875,11.19282590625,29.16606875,11.11093390625Q29.11136875,11.02904090625,29.04176875,10.95939690625Q28.97206875,10.88975290625,28.89016875,10.83503390625Q28.80826875,10.78031590625,28.71726875,10.74262490625Q28.62636875,10.70493390625,28.52976875,10.685718906249999Q28.43316875,10.66650390625,28.33466875,10.66650390625Q28.13576875,10.66650390625,27.95196875,10.74262390625Q27.76816875,10.81874490625,27.627568750000002,10.95939690625L27.62716875,10.95977190625L10.96123675,27.62570390625L10.96086175,27.626103906250002Q10.82020975,27.76670390625,10.74408975,27.95050390625Q10.66796875,28.13430390625,10.66796875,28.33320390625Q10.66796875,28.43170390625,10.687183749999999,28.52830390625Q10.70639875,28.62490390625,10.74408975,28.71580390625Q10.78178075,28.80680390625,10.83649875,28.88870390625Q10.89121775,28.97060390625,10.96086175,29.04030390625Q11.03050575,29.10990390625,11.11239875,29.16460390625Q11.19429075,29.21940390625,11.28528575,29.25700390625Q11.37627975,29.29470390625,11.47287875,29.31390390625Q11.56947735,29.33320390625,11.66796875,29.33320390625Q11.86688075,29.33320390625,12.05065175,29.25700390625Q12.23442275,29.18090390625,12.37507475,29.04030390625L29.04176875,12.37361090625L29.04176875,12.37360990625Z'
                fill-rule='evenodd'
                fill='#FFFFFF'
                fill-opacity='1'
              />
            </g>
          </g>
        </svg>
      </Tip>
    </>
  )
}

export default TopNotice
